/* CONTAINERS */
import Full from '@/containers/Full';

/* ADMIN MODULES */
import ActivityLog          from '@/router/admin/ActivityLog';
import Reports              from '@/router/admin/Reports';
import Banners              from '@/router/admin/Banners';
import Dashboard            from '@/router/admin/Dashboard';
import Onboarding           from '@/router/admin/Onboarding';
import Users                from '@/router/admin/Users';
import TrafficSources       from '@/router/admin/TrafficSources';
import Advertisers          from '@/router/admin/Advertisers';
import Triggers             from '@/router/admin/Triggers';
import Offers               from '@/router/admin/Offers';
import Approvals            from '@/router/admin/Approvals';
import TrafficSplitter      from '@/router/admin/TrafficSplitter';
import Tasks                from '@/router/admin/Tasks';
import Proxies              from '@/router/admin/Proxies';
import EmailTemplates       from '@/router/admin/EmailTemplates';
import Currencies           from '@/router/admin/Currencies';
import Blacklist            from '@/router/admin/Blacklist';
import Profile              from '@/router/admin/Profile';
import ExternalIntegrations from '@/router/admin/ExternalIntegrations';
import Schedules            from '@/router/admin/Schedules';
import TrafficFiltering     from '@/router/admin/TrafficFiltering';
import BlacklistControl     from '@/router/admin/BlacklistControl';
import FraudProtection      from '@/router/admin/FraudProtection';
import TrafficControl       from '@/router/admin/TrafficControl';
import KPIControl           from '@/router/admin/KPIControl';
import ForeignLeads         from '@/router/admin/ForeignLeads';

const children = [].concat(
    ActivityLog,
    Advertisers,
    Reports,
    Approvals,
    Banners,
    Dashboard,
    Offers,
    Onboarding,
    TrafficSources,
    TrafficSplitter,
    Triggers,
    Users,
    Tasks,
    Proxies,
    EmailTemplates,
    Currencies,
    Blacklist,
    Profile,
    ExternalIntegrations,
    Schedules,
    TrafficFiltering,
    BlacklistControl,
    FraudProtection,
    TrafficControl,
    KPIControl,
    ForeignLeads
);

children.forEach((module) => {
    const existingBeforeEnter = module.beforeEnter;

    module.beforeEnter = (to, from, next) => {
        existingBeforeEnter === 'function' ? existingBeforeEnter(to, from, next) : next();
    };

});

export default [{
    path: '/',
    redirect: '/dashboard',
    name: 'dashboard',
    component: Full,
    meta: {
        auth: true,
    },
    children,
}];
